import { render, staticRenderFns } from "./NavbarDefault.vue?vue&type=template&id=c470ccaa&"
import script from "./NavbarDefault.vue?vue&type=script&lang=js&"
export * from "./NavbarDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports